import React from "react";
import styled from "styled-components";
import { AlertTriangle, RefreshCw } from "lucide-react";

const Wrapper = styled.div`
  background: #fff;
  padding: 20px 16px 24px 16px;
  position: relative;
`;

const Inner = styled.div``;

const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  background: #fee2e2;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 4px;
`;

const Desc = styled.p`
  color: #6b7280;
  margin-bottom: 12px;
  font-size: 13px;
`;

const RetryButton = styled.button`
  background: #dc2626;
  &:hover {
    background: #b91c1c;
  }
  color: #fff;
  border-radius: 14px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  border: none;
`;

const RetryIcon = styled(RefreshCw)`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const SalesDashboardSummaryError = ({
  onRetry,
}: {
  onRetry?: () => void;
}) => {
  const handleRefresh = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <Wrapper>
      <Inner>
        <IconWrapper>
          <AlertTriangle
            width={18}
            height={18}
            color="#dc2626"
            strokeWidth={2}
          />
        </IconWrapper>
        <Title>데이터를 불러올 수 없습니다</Title>
        <Desc>매출 데이터를 불러오는 중 예상치 못한 오류가 발생했습니다.</Desc>
        <RetryButton onClick={handleRefresh}>
          <RetryIcon />
          다시 시도
        </RetryButton>
      </Inner>
    </Wrapper>
  );
};
